import "core-js/stable";
import { App } from "./components/App"

export default App
